/*
 *  This has been generated using the Synergy STDev tool.
 *  Any modifications will be lost after the next build
 */
import * as st from './STApp'
import { componentApi, loadTranslations } from 'common'


export class STViewApi {
  async GetViewDef(viewId : string) : Promise<st.ViewDef> {
    return await componentApi.call('st', 'st-view', 'STViewApi', 'GetViewDef', {
      viewId,
    });
  }
  async LoadViewDefinition(viewId : string) : Promise<st.ViewDefinition> {
    return await componentApi.call('st', 'st-view', 'STViewApi', 'LoadViewDefinition', {
      viewId,
    });
  }
  async LoadViewData(viewId : string, options : st.ViewDataLoadOptions) : Promise<st.ViewData> {
    return await componentApi.call('st', 'st-view', 'STViewApi', 'LoadViewData', {
      viewId,
      options,
    });
  }
}
export default new STViewApi()
